import { Play } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.55)), url('https://public.readdy.ai/ai/img_res/edited_7c77d54ccb0be505b93cc70638d18669_f6d8c2c7.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xl md:text-2xl mb-4 text-gray-200">
            {t('hero.subtitle')}
          </p>
          <p className="text-lg mb-8 text-gray-300 max-w-2xl mx-auto">
            {t('hero.description')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="primary" 
              size="lg"
              className="whitespace-nowrap cursor-pointer bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 text-lg"
            >
              {t('hero.cta')}
            </Button>
            
            <button className="flex items-center space-x-2 text-white hover:text-teal-300 transition-colors cursor-pointer">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <Play className="w-5 h-5 ml-1" />
              </div>
              <span className="text-lg whitespace-nowrap">{t('hero.watch')}</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
